<template>
  <div class="general">
      <smallbutton toplabel="Example" @click="Add()" buttonclass="buttonsmaller buttonprimary"/>
    <!-- ACCT NOTE MODAL -->
      <actionmodal ref="mymodal" > 
        <template v-slot:body>
                <div class="rightjustified">
                    <smallbutton @click="close()" toplabel='X' buttonclass="buttonclose" />
                </div>
                <div class="vertFlex margintop" >
 
                    <div class="fview" >
                        <div v-html="htmlWithSample" class="htmllabel"></div>
                        <!-- <froalaView v-model="htmlWithSample" /> -->
                    </div>

                    <div >
                        <smallbutton  @click="cancelupdate()" toplabel="Close" />
                    </div>
                </div>

               
       
        </template>
      </actionmodal>
      
  </div>
</template>

<script>

import smallbutton from '../controls/button.vue'
import actionmodal from '../actions/actionmodal.vue'
import datamethods from '../../datamethods.js'

export default {
    name: 'messageteexample',
    components:{
        smallbutton,
        actionmodal,
    },
    props:{
        templateId:{
            type:Number,
        },
  
        
    },
    mixins:[datamethods],
    data () {
        return {
            selectedResultID:0,
            lookupResults:[],
            selectedResult:{
                id:0,
                name:'',
                html:'',
                plain:'',
                sms:'',
                subject:'',
                IsActive:true,
                tokenList:[]
            },
        }
    },
    computed:{
        ToggleText(){
            if(this.showEdit){
                return "Show Example"
            }else{
                return "Hide Example"
            }
        },
        htmlWithSample(){
            var out = this.selectedResult.html
            console.log(out)
            out = out.replaceAll('[EmailAddress]','test@schoolvision.net')
            out = out.replaceAll('[FirstName]','Test')
            out = out.replaceAll('[LastName]','User')
            out = out.replaceAll('[BadgeNumber]','123456')
            console.log(out)
            return out
        },
    },
    methods:{
        close(){
            this.$emit('refresh')
            this.$refs.mymodal.closeModal()
        },
        toggleSample(){
            this.showEdit=!this.showEdit
        },
        select(result){
            this.selectedResult=result;
            this.selectedResultID=result.id;
            
        },
        async Add(){
            this.getTemplates()
            
            
        },
        
       async getTemplates(){
            let req = {
                MessageTemplate:{
                    id:this.templateId
                }
            }
            var response = await this.callAPI(req,'template')
            if(response.Successful){
                console.log(response)
                
                this.selectedResult=response.MessageTemplateList[0]
                this.$refs.mymodal.openModal()
            }else{
                //this.message = response.Message
            }

        },

        cancelupdate(){
            this.$refs.mymodal.closeModal()
        },
        
        
    }
}
</script>

<style>
.general{
    font-size:medium;
}
.smalltext{
    font-size:small;
}
.margintop{
    margin-top:20px;
}
.fview{
    background-color: white;
    padding:5px;
    text-align: left;
}
/* textarea{
    visibility: collapse;
    height: 0px;
} */
</style>